import { render } from "./CircleIcon.vue?vue&type=template&id=94124b7e"
import script from "./CircleIcon.vue?vue&type=script&lang=js"
export * from "./CircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__